import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import styles from './BlockList.scss';
import { BlockListItem } from './BlockListItem';
export var BlockList = /*#__PURE__*/function (_React$Component) {
  _inherits(BlockList, _React$Component);

  var _super = _createSuper(BlockList);

  function BlockList(props) {
    var _this;

    _classCallCheck(this, BlockList);

    _this = _super.call(this, props);

    _this.onItemClicked = function (indexClicked) {
      _this.setState({
        selectedIndex: indexClicked
      });

      _this.props.onSelectedIndexChanged(indexClicked);
    };

    _this.onItemFocused = function (indexFocused) {
      _this.setState({
        activeFocusIndex: indexFocused
      });
    };

    _this.onKeyDown = function (event) {
      var children = _this.props.children;
      var activeFocusIndex = _this.state.activeFocusIndex;
      var lastChildIndex = React.Children.count(children);

      if (event.key === 'ArrowUp') {
        if (activeFocusIndex === 0) {
          return _this.onItemFocused(lastChildIndex - 1);
        }

        return _this.onItemFocused(activeFocusIndex - 1);
      } else if (event.key === 'ArrowDown') {
        if (activeFocusIndex + 1 === lastChildIndex) {
          return _this.onItemFocused(0);
        }

        return _this.onItemFocused(activeFocusIndex + 1);
      } else if (event.key === 'Enter') {
        return _this.onItemClicked(activeFocusIndex);
      }

      return;
    };

    var selectedIndex = props.selectedIndex;
    _this.state = {
      selectedIndex: selectedIndex,
      activeFocusIndex: selectedIndex !== null ? selectedIndex : 0
    };
    return _this;
  }

  _createClass(BlockList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedIndex !== prevProps.selectedIndex) {
        this.setState({
          selectedIndex: this.props.selectedIndex,
          activeFocusIndex: this.props.selectedIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          dataTest = _this$props.dataTest,
          children = _this$props.children;
      var _this$state = this.state,
          selectedIndex = _this$state.selectedIndex,
          activeFocusIndex = _this$state.activeFocusIndex;
      return React.createElement("ul", {
        role: "listbox",
        "data-test": dataTest,
        tabIndex: 0,
        "aria-activedescendant": activeFocusIndex !== null && "list-item-".concat(activeFocusIndex),
        onKeyDown: this.onKeyDown,
        className: styles.container
      }, React.Children.map(children, function (child, index) {
        return React.cloneElement(child, {
          id: "list-item-".concat(index),
          selected: selectedIndex === index,
          focused: activeFocusIndex === index,
          lastItem: index === React.Children.count(children) - 1,
          dataTest: "list-item-".concat(index),
          onClick: function onClick() {
            return _this2.onItemClicked(index);
          },
          onMouseEnter: function onMouseEnter() {
            return _this2.onItemFocused(index);
          }
        });
      }));
    }
  }]);

  return BlockList;
}(React.Component);
BlockList.Item = BlockListItem;
BlockList.defaultProps = {
  selectedIndex: null,
  onSelectedIndexChanged: function onSelectedIndexChanged() {}
};